import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { addNewExchange } from "../actions/currency";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import Select from "react-select";
import { CheckFactory } from "../Hooks/useWeb3";
import toast from "react-hot-toast";
const AddExchangeModal = ({ show, handleClose, getAllExchanges }) => {
  const [formvalue, setFormvalue] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedChain, setSelectedChain] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  const chainOptions = [
    { value: 56, label: "BSC" },
    { value: 137, label: "Polygon" },
    { value: 1, label: "ETH" },
    { value: 324, label: "zksync" },
    { value: 10, label: "optimism" },
    { value: 42161, label: "arbitrumgit" },

  ];

  const typeOptions = [
    { value: "v2", label: "V2" },
    { value: "v3", label: "V3" },
  ];

  const addressRegex = /^(0x)[0-9A-Fa-f]{40}$/;

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    let updatedForm = { ...formvalue, [name]: value };

    if (name === "router" && selectedChain) {
      const fact = await CheckFactory(value, selectedChain.value);
      if (fact.status) {
        updatedForm.chainId = selectedChain.value;
        updatedForm.factory = fact.data;
        setErrors((prev) => ({ ...prev, router: "", factory: "" }));
      } else {
        updatedForm.chainId = "";
        updatedForm.factory = "";
        setErrors((prev) => ({ ...prev, router: "Enter a valid router address" }));
      }
    }

    setFormvalue(updatedForm);
  };

  const handleChainChange = async (selectedOption) => {
    setSelectedChain(selectedOption);
    if (formvalue.router) {
      const fact = await CheckFactory(formvalue.router, selectedOption.value);
      if (fact.status) {
        setFormvalue((prev) => ({ ...prev, chainId: selectedOption.value, factory: fact.data }));
        setErrors((prev) => ({ ...prev, router: "", factory: "" }));
      } else {
        setErrors((prev) => ({ ...prev, router: "Enter a valid router address" }));
      }
    }
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
    setFormvalue((prev) => ({ ...prev, type: selectedOption.value }));
    setErrors((prev) => ({ ...prev, type: "" }));
  };

  const validate = (value) => {
    const error = {};
    if (isEmpty(value.exchange)) error.exchange = "Field is required";
    if (isEmpty(value.factory)) error.factory = "Field is required";
    if (isEmpty(value.router)) error.router = "Field is required";
    else if (!addressRegex.test(value.router)) error.router = "Invalid address format";
    if (!value.chainId) error.chainId = "Field is required";
    if (!value.type) error.type = "Field is required";
    if (isEmpty(value.logoURI)) error.logoURI = "Field is required";
    return error;
  };

  const handleSubmit = async () => {
    const errorObj = validate(formvalue);
    setErrors(errorObj);
    if (!ObjectIsempty(errorObj)) return;

    const { status, message } = await addNewExchange(formvalue);
    if (status === "success") {
      toast.success("Exchange Added Successfully");
    } else {
      toast.error(message || "Failed to add exchange");
    }
    cleanupAndClose();
  };

  const cleanupAndClose = () => {
    setFormvalue({});
    setErrors({});
    setSelectedChain(null);
    setSelectedType(null);
    handleClose();
    getAllExchanges();
  };

  const customSelectStyles = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      backgroundColor: isHovered || isFocused || isSelected ? "#00ddeb" : "#000",
      color: isHovered || isFocused || isSelected ? "#000" : "#fff",
      fontSize: "13px",
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",
      fontSize: "13px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      padding: 0,
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "#fff",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      borderRadius: 5,
      background: "transparent",
    }),
  };

  return (
    <Modal centered className="cmn_modal" show={show} onHide={cleanupAndClose} backdrop="static" keyboard={false}>
      <Modal.Body>
        <div className="cmn_modal_header d-flex justify-content-between align-items-center">
          <p className="cmn_modal_title">Add Exchange</p>
          <button className="cmn_modal_closer rounded-5" onClick={cleanupAndClose}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="mt-4">
          {[
            { label: "Name", name: "exchange", type: "text", placeholder: "Enter Exchange Name" },
            { label: "Router", name: "router", type: "text", placeholder: "Enter Router Address" },
            { label: "Logo URI", name: "logoURI", type: "text", placeholder: "Enter Logo URI" },
          ].map(({ label, name, type, placeholder }) => (
            <div className="rp_singleinput_holder mb-3" key={name}>
              <p className="rp_label mb-2">{label}</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center gap-2">
                <input
                  type={type}
                  name={name}
                  placeholder={placeholder}
                  value={formvalue[name] || ""}
                  className="rp_singleInput flex-grow-1"
                  onChange={handleInputChange}
                />
              </div>
              <span className="text-danger">{errors[name]}</span>
            </div>
          ))}

          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Chain ID</p>
            <div className="rp_input_holder rounded-2 px-0">
              <Select
                onChange={handleChainChange}
                options={chainOptions}
                value={selectedChain}
                classNamePrefix="customselect"
                isSearchable={false}
                styles={customSelectStyles}
              />
            </div>
            <span className="text-danger">{errors.chainId}</span>
          </div>

          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Factory</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center gap-2">
              <input
                type="text"
                name="factory"
                placeholder="Factory will be auto filled"
                value={formvalue.factory || ""}
                className="rp_singleInput flex-grow-1"
                readOnly
              />
            </div>
            <span className="text-danger">{errors.factory}</span>
          </div>

          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Type</p>
            <div className="rp_input_holder rounded-2 px-0">
              <Select
                onChange={handleTypeChange}
                options={typeOptions}
                value={selectedType}
                classNamePrefix="customselect"
                isSearchable={false}
                styles={customSelectStyles}
              />
            </div>
            <span className="text-danger">{errors.type}</span>
          </div>

          <button className="orange_small_primary mt-3" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddExchangeModal;
